export function isTruncated(target: HTMLElement): boolean {
    const { width: elementWidth } = target.getBoundingClientRect();

    const range = document.createRange();
    range.selectNodeContents(target);
    const { width: contentWidth } = range.getBoundingClientRect();

    return contentWidth > elementWidth;
}
